
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 101.03 84.6"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(-20 -28.13)"}},[_c('path',{attrs:{"fill":"none","d":"M20 28.13h101.03v84.6H20z"}})])]),_c('path',{staticClass:"prt-icon-color",attrs:{"d":"M84.35 20.76V3.77H74.06v10.24l10.29 6.75zM9.28 82.9h82.46v1.7H9.28z"}}),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M60.38 62.52h-4.8v-18.1a16.57 16.57 0 01-6.2 3.64V43.7a14 14 0 004.08-2.33 8.91 8.91 0 003-4h3.89v25.15zm-14.03-6.65h-9.43v-4.8h9.43zM101 34.53L50.51 0 0 34.53h9.28v46.16h82.46V34.53z","fill":"#b0b2b3"}})])])
          )
        }
      }
    